import { IBootstrapTableColumnProps } from 'react-bootstrap-table-next';
import { convertColumnsToWrapBoldText } from '../../../../../utilities/escrowPortal/convertColumnsToWrapText';
import { Currency } from '../../../../../ui-toolkit';
import { IEscrowMatchAchPullDepositResponse } from '../../../../../types/accounting/response/IEscrowExpectedAchPullDepositResponse';
import React from 'react';
import { DateFormat, getDateString } from '../../../../../ui-toolkit/utilities/getDateString';

export const generateAchPullDepositTableColumns = (): IBootstrapTableColumnProps<any>[] =>
  convertColumnsToWrapBoldText([
    {
      dataField: 'amountCents',
      text: 'Amount',
      formatter: (cell) => <Currency value={cell} valueIsCents />,
    },
    {
      dataField: 'payerType',
      text: 'Payer Type',
    },
    {
      dataField: 'bankAccount.nickname',
      text: 'Spruce Account Label',
    },
    {
      dataField: 'bankAccount.accountLabel',
      text: 'Spruce Account',
    },
    {
      dataField: 'achAccount.name',
      text: 'Receiving Party Name',
    },
    {
      dataField: 'achAccount.accountType',
      text: 'Receiving Party Account Type',
    },
    {
      dataField: 'achAccount.accountNumber',
      text: 'Receiving Party Account #',
    },
    {
      dataField: 'achAccount.routingNumber',
      text: 'Receiving Party Routing #',
    },
    {
      dataField: 'memo',
      text: 'Memo',
    },
    {
      dataField: 'wellsFargoTransactionNumber',
      text: 'Wells Fargo Transaction Number',
    },
    {
      dataField: 'enqueuedForDisbursementAt',
      text: 'Sent At',
      formatter: (cell) => getDateString(DateFormat.hugeDateTime, cell, true),
    },
    {
      dataField: 'processingForDisbursementStartedAt',
      text: 'Disbursed At',
    },
    {
      dataField: 'matches',
      text: 'Completed At',
      formatter: ((cell: Array<IEscrowMatchAchPullDepositResponse>) => (
        <>{`${cell.map((match) => match.actual?.asOfTimestamp)}`}</>
      )) as (cell: any) => React.ReactNode,
    },
  ]);
